import { fbpTrack } from 'src/helpers/pixel'

export const useFbp = () => {
  const fbpTrackViewContentSignupStep1 = () => {
    fbpTrack('PageView')
    fbpTrack('ViewContent', { content_name: 'register_step1' })
  }
  const fbpTrackViewContentSignupStep2 = () => {
    fbpTrack('PageView')
    fbpTrack('ViewContent', { content_name: 'register_step2' })
  }
  const fbpTrackSubmitApplication = (data?: any) => {
    if (data) {
      fbpTrack('SubmitApplication', data)
    } else {
      fbpTrack('SubmitApplication')
    }
  }

  const fbpTrackRegistration = (data?: any) => {
    if (data) {
      fbpTrack('CompleteRegistration', data)
    } else {
      fbpTrack('CompleteRegistration')
    }
  }

  return {
    fbpTrackViewContentSignupStep1,
    fbpTrackViewContentSignupStep2,
    fbpTrackSubmitApplication,
    fbpTrackRegistration
  }
}
